module.exports = __webpack_public_path__ + "static/media/5.f92b32c5.jpg";